export const GET_TESTIMONI = 'GET_TESTIMONI';
export const SET_TESTIMONI = 'SET_TESTIMONI';
export const CLEAR_TESTIMONI = 'CLEAR_TESTIMONI';
export const CREATE_TESTIMONI = 'CREATE_TESTIMONI';
export const DELETE_TESTIMONI = 'DELETE_TESTIMONI';
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
